import * as angular from "angular";
import {IController, IScope} from "angular";
import * as _ from "lodash";

export class serviceAreasListCtrl implements IController {

  infiniteScroll: any;
  searchQuery: string;
  selectedFeature: any;
  onSelect: Function;
  onEdit: Function;
  onDelete: Function;
  onExportGeoJson: Function;
  onExportKml: Function;

  private static readonly DEFAULT_ITEM_HEIGHT = 90;
  private static readonly MAX_LOAD_ATTEMPTS = 50;

  private _scrollTimeoutHandle: any;

  /* @ngInject */
  constructor(private $scope: IScope, private $element, private $timeout) {
  }

  $onInit() {
    this.$scope.$on('anchor-scroll', (event, id) => {
      this._scrollToServiceArea(id);
    });
  }

  $onDestroy() {
    if (this._scrollTimeoutHandle) {
      this.$timeout.cancel(this._scrollTimeoutHandle);
    }
  }

  private _scrollToServiceArea(id, attempts = 0) {
    if (!id || !this.infiniteScroll) {
      return;
    }

    const index = _.findIndex(this.infiniteScroll._items, (item: any) => item.id === id);
    if (index !== -1) {
      this._scrollToIndex(index);
      return;
    }

    // Item is not in the loaded page yet (list is paged on-demand): pull the next page
    // through the same API md-virtual-repeat uses, then retry until found or exhausted.
    if (attempts >= serviceAreasListCtrl.MAX_LOAD_ATTEMPTS || this.infiniteScroll.isFinished()) {
      return;
    }
    this.infiniteScroll.getItemAtIndex(_.size(this.infiniteScroll._items));
    this._scrollTimeoutHandle = this.$timeout(() => this._scrollToServiceArea(id, attempts + 1), 150);
  }

  private _scrollToIndex(index) {
    this.$timeout(0).then(() => {
      const scroller = this.$element[0].querySelector('.md-virtual-repeat-scroller');
      if (scroller) {
        scroller.scrollTop = index * this._getItemHeight();
      }
    });
  }

  private _getItemHeight(): number {
    const item = this.$element[0].querySelector('.repeated-item');
    return (item && item.offsetHeight) || serviceAreasListCtrl.DEFAULT_ITEM_HEIGHT;
  }

}

angular
  .module('bringoz.admin.service-areas')
  .component('serviceAreasList', {
    bindings: {
      infiniteScroll: '<',
      selectedFeature: '<',
      onSelect: '&',
      onEdit: '&',
      onDelete: '&',
      onExportGeoJson: '&',
      onExportKml: '&'
    },
    template: require('./service-areas-list.html').default,
    controller: serviceAreasListCtrl
  });
